<template>
	<Drawer component="UserProfile" blockScroll
			v-model:visible="isVisible"
			header="Profil"
			position="right"
			:style="{ width: '500px' }"
	>
		<main>
			<div class="inputs">
				<FloatLabel variant="on">
					<InputText id="keywords" v-model="authStore.user.name" disabled />
					<label for="keywords">Meno</label>
				</FloatLabel>
				<FloatLabel variant="on">
					<InputText id="keywords" v-model="authStore.user.surname" disabled />
					<label for="keywords">Priezvisko</label>
				</FloatLabel>
				<FloatLabel variant="on">
					<InputText id="keywords" v-model="authStore.user.email" disabled />
					<label for="keywords">Emailová adresa</label>
				</FloatLabel>
			</div>
			<footer>
				<button class="iRight" icon="power_settings_new" @click="logout">
					Odhlásiť sa
				</button>
				<div class="info">
					<div v-if="authStore.isUserM7" class="default">
						<p v-show="authStore.user?.id"><strong>ID:</strong> {{ authStore.user?.id }}</p>
					</div>
				</div>
			</footer>
		</main>
	</Drawer>
</template>

<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@stores/';
import NavigationMenu from '@components/navigation/Navigation.menu.vue';

export default defineComponent({
	name: 'UserProfile',
	components: { NavigationMenu },

	setup() {
		const { t } = useI18n();
		const authStore = useAuthStore();
		const router = useRouter();

		return { t, authStore, router };
	},

	props: {
		modelValue: {
			type: Boolean,
			default: false
		}
	},

	data: () => ({}),

	mounted() {
	},

	computed: {
		isVisible: {
			get() {
				return this.modelValue;
			},
			set(val) {
				this.$emit('update:modelValue', val);
			}
		}
	},

	methods: {
		async logout() {
			await this.authStore.logout();
			await this.router.push({ name: 'Login' });
		}
	}
});
</script>

<style lang="scss" scoped>

[component='UserProfile'] {
	main {
		display: flex;
		flex-direction: column;
		gap: 24px;
		padding: 20px;

		.inputs {
			display: flex;
			flex-direction: column;
			gap: 20px;

			:deep(.p-multiselect),
			input,
			textarea,
			.p-treeselect {
				width: 100%;
			}
		}

		:deep(.p-fieldset-content) {
			display: flex;
			gap: 4px;
			flex-wrap: wrap;
		}

		footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}
}
</style>
